'use strict';

/**
 * Config for the router
 */
angular.module('app')
  .run(
    ['$rootScope', '$state', '$stateParams', '$location',
      function ($rootScope,   $state,   $stateParams, $location) {
          $rootScope.$state = $state;
          $rootScope.$stateParams = $stateParams;
          $rootScope.$aurl = aurl;
          $rootScope.$bdomain = MyAjax.domain;
          /*
           $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
               // event.preventDefault(); 
                var path = $location.path();
                if($rootScope.$auth && $rootScope.$auth == 'logout' )
                    $state.go('access.signin');
                
           
            });
          */
         
//         $rootScope.$on('$stateChangeStart', 
//            function(event, toState, toParams, fromState, fromParams){ 
//                //event.preventDefault(); 
//                // transitionTo() promise will be rejected with 
//                // a 'transition prevented' error
//                
//                console.log($rootScope.$auth);
//            })
          
      }
    ]
  )
   .run(function($rootScope, $templateCache) {
    $rootScope.$on('$routeChangeStart', function(event, next, current) {
        if (typeof(current) !== 'undefined'){
            $templateCache.remove(current.templateUrl);
        }
    });
})
  .config(
    [          '$stateProvider', '$urlRouterProvider',
      function ($stateProvider,   $urlRouterProvider) {
          
          $urlRouterProvider.when('/app/database/////', '/app/database/allContinents/allCountries/allCategories/allEntries/');
          
          $urlRouterProvider
              .otherwise('/app/homepage');
          $stateProvider
              .state('app', {
                  abstract: true,
                  url: '/app',
                  templateUrl: aurl + 'tpl/app.html'
              })
              .state('app.homepage', {
                  url: '/homepage',
                  templateUrl: aurl + 'tpl/homepage.html',
                  resolve: {
                      deps: ['uiLoad',
                        function( uiLoad ){
                          return uiLoad.load( [aurl + 'js/directives/flags.js',
                                               aurl + 'vendor/jquery/highlight/jquery.jmHighlight.min.js', 
                                               aurl + 'js/data/countries2015.js',
                                               aurl + 'js/data/categories.js',
                                               
                                                //Modal
                                               aurl + 'vendor/angular/angular-dialog/css/ngDialog.css',
                                               aurl + 'vendor/angular/angular-dialog/css/ngDialog-theme-default.min.css',
                                               aurl + 'vendor/angular/angular-dialog/css/ngDialog-theme-plain.css',
                                               aurl + 'vendor/angular/angular-dialog/css/ngDialog-custom-width.css',
                                               
                                               //aurl + 'js/controllers/chart.js',
                                               aurl + 'js/controllers/homepage.js',
                                               aurl + 'css/flags.css'] );
                      }]
                  }
              })
              
 
              .state('app.database', {
                  url: '/database/:landId/:countryId/:categoryId/:periodTyp/:filterData',
                  //url: '/database/',
                  templateUrl: aurl + 'tpl/database.html',
                    resolve: {
                      deps: ['uiLoad',
                        function( uiLoad ){
                          return uiLoad.load( [
                                               //Filter
                                               aurl + 'js/directives/flags.js',
                                               aurl + 'vendor/angular/angular-multiselect/isteven-multi-select.css',
                                               aurl + 'js/data/countries2015.js',
                                               aurl + 'js/data/categories.js',
                                               aurl + 'css/flags.css',
                                               //Modal
                                               aurl + 'vendor/angular/angular-dialog/css/ngDialog.css',
                                               aurl + 'vendor/angular/angular-dialog/css/ngDialog-theme-default.min.css',
                                               aurl + 'vendor/angular/angular-dialog/css/ngDialog-theme-plain.css',
                                               aurl + 'vendor/angular/angular-dialog/css/ngDialog-custom-width.css',
                                               //aurl + 'vendor/angular/angular-dialog/js/ngDialog.js',
                                               //Datatable scripts
                                               aurl + 'vendor/jquery/datatables/jquery.dataTables.min.js',
                                               aurl + 'vendor/jquery/datatables/jquery.dataTables.min.css',
                                               aurl + 'vendor/jquery/datatables/dataTables.responsive.min.js',
                                               aurl + 'vendor/jquery/datatables/responsive.dataTables.min.css',
                                               aurl + 'vendor/jquery/datatables/dataTables.colVis.min.js',
                                               aurl + 'vendor/jquery/datatables/dataTables.colVis.min.css',
                                               aurl + 'vendor/jquery/datatables/dataTables.colvis.jqueryui.css',
                                               //SWF
//                                               aurl + 'vendor/jquery/datatables/dataTables.tableTools.js',
//                                               aurl + 'vendor/jquery/datatables/dataTables.tableTools.css',
                                               //HTML5         
                                               aurl + 'vendor/jquery/datatables/dataTables.buttons.min.js',
                                               aurl + 'vendor/jquery/datatables/jszip.min.js',
                                               aurl + 'vendor/jquery/datatables/buttons.html5.min.js',
                
                                               aurl + 'vendor/jquery/datatables/dataTables.fixedHeader.min.js',
                                               
                                               //Rate
                                               aurl + 'vendor/angular/angular-rateit/ng-rateit.css',
                                               //aurl + 'vendor/angular/angular-rateit/ng-rateit.min.js'
                                               
                                               //PhotoSwipe
//                                               aurl + 'vendor/libs/PhotoSwipe/photoswipe.css',
//                                               aurl + 'vendor/libs/PhotoSwipe/default-skin/default-skin.css',
//                                               aurl + 'vendor/libs/PhotoSwipe/photoswipe.min.js',
//                                               aurl + 'vendor/libs/PhotoSwipe/photoswipe-ui-default.min.js',

                                               //zooming.js 
                                               aurl + 'vendor/libs/zooming/zooming.min.js',
                                               
                                               //gmap
                                               
                                               //Data
                                               aurl + 'js/controllers/datatable.js',
                                               aurl + 'js/controllers/export.js'
                                               
                                               
                                               ] );
                      }]
                  }    
              })
              
              .state('app.favorites', {
                  //url: '/favorites',
                  url: '/favorites/',
                  templateUrl: aurl + 'tpl/favorites.html',
                  data: {
                        favorites: 'true',
                    },
                    resolve: {
                      deps: ['uiLoad',
                        function( uiLoad ){
                          return uiLoad.load( [
                                               aurl + 'js/data/countries2015.js',
                                               aurl + 'js/data/categories.js',
                                               //Modal
                                               aurl + 'vendor/angular/angular-dialog/css/ngDialog.css',
                                               aurl + 'vendor/angular/angular-dialog/css/ngDialog-theme-default.min.css',
                                               aurl + 'vendor/angular/angular-dialog/css/ngDialog-theme-plain.css',
                                               aurl + 'vendor/angular/angular-dialog/css/ngDialog-custom-width.css',
                                               //aurl + 'vendor/angular/angular-dialog/js/ngDialog.js',
                                               //Datatable scripts
                                               aurl + 'vendor/jquery/datatables/jquery.dataTables.min.js',
                                               aurl + 'vendor/jquery/datatables/jquery.dataTables.min.css',
                                               aurl + 'vendor/jquery/datatables/dataTables.responsive.min.js',
                                               aurl + 'vendor/jquery/datatables/responsive.dataTables.min.css',
                                               aurl + 'vendor/jquery/datatables/dataTables.colVis.min.js',
                                               aurl + 'vendor/jquery/datatables/dataTables.colVis.min.css',
                                               aurl + 'vendor/jquery/datatables/dataTables.colvis.jqueryui.css',
  //SWF
//                                               aurl + 'vendor/jquery/datatables/dataTables.tableTools.js',
//                                               aurl + 'vendor/jquery/datatables/dataTables.tableTools.css',
                                               //HTML5         
                                               aurl + 'vendor/jquery/datatables/dataTables.buttons.min.js',
                                               aurl + 'vendor/jquery/datatables/jszip.min.js',
                                               aurl + 'vendor/jquery/datatables/buttons.html5.min.js',
                                               
                                               aurl + 'vendor/jquery/datatables/dataTables.fixedHeader.min.js',
                                               
                                               //Data
                                               aurl + 'js/controllers/datatable.js',
                                               aurl + 'js/controllers/export.js',
                                               //Rate
                                               aurl + 'vendor/angular/angular-rateit/ng-rateit.css'] );
                                           
                      }]
                  }    
              })
              .state('app.notices', {
                  url: '/notices/:compId',
                  templateUrl: aurl + 'tpl/comment.html',
                  resolve: {
                      deps: ['uiLoad',
                        function( uiLoad ){
                          return uiLoad.load( [aurl + 'js/controllers/comment.js',
                                               aurl + 'vendor/ujimoto/ujiDots.js',
                                               aurl + 'vendor/ujimoto/ujiDots.css',

                                                aurl + 'vendor/jquery/ckeditor/ckeditor.js',
                                                aurl + 'vendor/jquery/ckeditor/samples/toolbarconfigurator/lib/codemirror/neo.css',
                                               
                                               //Modal
                                               aurl + 'vendor/angular/angular-dialog/css/ngDialog.css',
                                               aurl + 'vendor/angular/angular-dialog/css/ngDialog-theme-default.min.css',
                                               aurl + 'vendor/angular/angular-dialog/css/ngDialog-theme-plain.css',
                                               aurl + 'vendor/angular/angular-dialog/css/ngDialog-custom-width.css',
                                               //Textangular
                                               //aurl + 'vendor/angular/textangular/textAngular.css'
                                            ] );
                      }]
                  }
              })
              .state('app.profile', {
                   url: '/profile',
                  templateUrl: aurl + 'tpl/profile.html',
                  resolve: {
                    deps: ['$ocLazyLoad',
                      function( $ocLazyLoad ){
                        return $ocLazyLoad.load([aurl + 'js/controllers/profile.js']);
                    }]
                  }
              })
              .state('app.support', {
                  url: '/support',
                  templateUrl: aurl + 'tpl/support.html',
                  resolve: {
                    deps: ['$ocLazyLoad',
                      function( $ocLazyLoad ){
                        return $ocLazyLoad.load([aurl + 'js/controllers/support.js']);
                    }]
                  }
              })
              .state('app.docs', {
                  url: '/docs',
                  templateUrl: aurl + 'tpl/docs.html'
              })
              .state('app.dashboard-v1', {
                  url: '/dashboard-v1',
                  templateUrl: aurl + 'tpl/app_dashboard_v1.html',
                  resolve: {
                    deps: ['$ocLazyLoad',
                      function( $ocLazyLoad ){
                        return $ocLazyLoad.load([aurl + 'js/controllers/chart.js']);
                    }]
                  }
              })
//              .state('lockme', {
//                  url: '/lockme',
//                  templateUrl:  aurl + 'tpl/logged.html',
//                  controller: 'SigninFormController',
////                   resolve: {
////                      deps: ['uiLoad',
////                        function( uiLoad ){
////                          return uiLoad.load( [aurl + 'main.js',
////                                               aurl + 'js/signin.js'] );
////                      }]
////                  }
//                   resolve: {
//                    deps: ['$ocLazyLoad',
//                      function( $ocLazyLoad ){
//                        return $ocLazyLoad.load([aurl + 'js/signin.js']);
//                    }]
//                  }
//              })              
              .state('app.dashboard-v2', {
                  url: '/dashboard-v2',
                  templateUrl: aurl + 'tpl/app_dashboard_v2.html',
                  resolve: {
                    deps: ['$ocLazyLoad',
                      function( $ocLazyLoad ){
                        return $ocLazyLoad.load([aurl + 'js/controllers/chart.js']);
                    }]
                  }
              })
          
      }
    ]
  );